import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatOperationActionTypes {
  SetPending = 'chatOperation/setPending',
  AddToArchive = 'chatOperation/addToArchive',
  RemoveFromArchive = 'chatOperation/removeFromArchive',
  AddToSpam = 'chatOperation/addToSpam',
  RemoveFromSpam = 'chatOperation/removeFromSpam',
}

export type TChatOperationActions =
  | ITypedReduxAction<EChatOperationActionTypes.SetPending, boolean>
  | ITypedReduxAction<EChatOperationActionTypes.AddToArchive, string>
  | ITypedReduxAction<EChatOperationActionTypes.RemoveFromArchive, string>
  | ITypedReduxAction<EChatOperationActionTypes.AddToSpam, string>
  | ITypedReduxAction<EChatOperationActionTypes.RemoveFromSpam, string>;
